import classNames from 'classnames';
import React from 'react';
import { OptionProps, GroupBase, components } from 'react-select';
import { SelectOption } from '../../..';
import { SpanTooltip } from '../../../../SpanTooltip';
import { TruncateText } from '../../../../TruncateText';

function OptionBody(
  props: OptionProps<SelectOption, false, GroupBase<SelectOption>>,
) {
  return (
    <div
      className={classNames(
        'd-flex flex-nowrap',
        { 'justify-content-between': !props.isMulti },
        props.data.classNames,
      )}
    >
      {props.isMulti && (
        <input
          type='checkbox'
          checked={props.isSelected}
          onChange={(e) => {
            e.stopPropagation();
          }}
          disabled={props.isDisabled}
          className='form-check-input me-2'
        />
      )}
      <TruncateText
        text={props.data.label}
        ellipsize={true}
        tooltip={true}
        className={classNames(props.isDisabled && 'text-gray-700')}
      />
      {props.data.subLabel}
    </div>
  );
}

export function DefaultOption(
  props: OptionProps<SelectOption, false, GroupBase<SelectOption>>,
) {
  const optionData: SelectOption = props.data as SelectOption;

  return (
    <components.Option<SelectOption, false, GroupBase<SelectOption>> {...props}>
      {optionData.tooltipText ? (
        <SpanTooltip
          text={<OptionBody {...props} />}
          tooltipText={optionData.tooltipText}
          placement='top-end'
        />
      ) : (
        <OptionBody {...props} />
      )}
    </components.Option>
  );
}
